export const GET_FOOD_REQUEST = "GET_FOOD_REQUEST";
export const GET_FOOD_SUCCESS = "GET_FOOD_SUCCESS";
export const GET_FOOD_FAILURE = "GET_FOOD_FAILURE";
export const SELECTED_FOOD = "SELECTED_FOOD";
